import { Row } from "antd";

import HighnoteSignature from "components/highnote-signature/highnote-signature";

import { AppBrand } from "constants/field-values";
import { useBrand } from "context/BrandContext";
import { useNavProfile } from "hooks/useNavProfile";
import { ReactNode } from "react";

const SimpleLoginLayout = ({ children }: { children?: ReactNode }) => {
  const { brand, theme } = useBrand();
  const isBrandNotHighnote = brand !== AppBrand.Highnote;
  const { navProfile } = useNavProfile();
  const isOllieBrand = navProfile.sidebarBrand === "ollie";

  return (
    <div className="login-container">
      <Row className="login-top-row">
        <div className="email-verification-content-container">
          <div className="login-logo-container">
            <img
              src={`${process.env.PUBLIC_URL}${theme.loginLogo}`}
              className="logo"
              width={250}
            />
          </div>
          {children}
        </div>

        <footer className="login-footer">
          {isOllieBrand ? null : isBrandNotHighnote ? (
            <HighnoteSignature />
          ) : (
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/icons/highnote-login-footer.svg`}
            />
          )}
        </footer>
      </Row>

      <Row className="login-bottom-row"></Row>
    </div>
  );
};

export default SimpleLoginLayout;
